export interface StateInterface {
  filter: boolean;
  homeUnitsSelected: number[];
  seniorsToSelect: SeniorInterface[];
  focusedSeniors: SeniorInterface[];
}

export interface SeniorsidentificationmanagerProps {
  seniors: SeniorInterface[];
  initialSeniorsSelected: SeniorInterface[];
  setSeniorsSelected: Function;
  homeUnits: { id: number; name: string }[];
  text: {
    senior: string;
    seniors: string;
    noSeniorSelected: string;
    warningSeniorFocused: string;
    selectSenior: string;
    homeUnit: string;
    filterBy: string;
    selectedSeniors: string;
  };
}

export interface SeniorInterface {
  id: number;
  value: number;
  label: string;
  name: string;
  homeUnitId: number;
}

export interface HomeUnitInterface {
  id: number;
  name: string;
}

const handleHomeUnit = (
  homeUnitsSelected: number[],
  homeUnitId: number,
  focusedSeniors: SeniorInterface[],
  seniors: SeniorInterface[]
) => {
  const seniorsFromThisHomeUnit = seniors.filter(
    (senior) => senior.homeUnitId === homeUnitId
  ).length;
  const focusedSeniorsFromThisHomeUnit = focusedSeniors.filter(
    (senior) => senior.homeUnitId === homeUnitId
  ).length;
  if (seniorsFromThisHomeUnit === focusedSeniorsFromThisHomeUnit) {
    return [...homeUnitsSelected, homeUnitId];
  } else {
    return homeUnitsSelected.includes(homeUnitId)
      ? homeUnitsSelected.filter((hu) => hu !== homeUnitId)
      : homeUnitsSelected;
  }
};

export const SeniorsIdentificationReducer = (
  state: StateInterface,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case "SET_FILTER": {
      return {
        ...state,
        filter: true,
        seniorsToSelect: action.payload,
      };
    }
    case "SET_NO_FILTER": {
      return {
        ...state,
        filter: action.payload,
        homeUnitsSelected: [],
        seniorsToSelect: [],
        focusedSeniors: [],
      };
    }
    case "SET_HOME_UNIT": {
      const seniorsFromThisHomeUnit = action.payload.seniors.filter(
        (senior: SeniorInterface) =>
          senior.homeUnitId === action.payload.homeUnit
      );
      const seniorsFromThisHomeUnitIds = seniorsFromThisHomeUnit.map(
        (senior: SeniorInterface) => senior.id
      );
      const focusedSeniorsIds = state.focusedSeniors.map((senior) => senior.id);
      if (state.homeUnitsSelected.includes(action.payload.homeUnit)) {
        return {
          ...state,
          homeUnitsSelected: state.homeUnitsSelected.filter(
            (homeUnit: number) => homeUnit !== action.payload.homeUnit
          ),
          seniorsToSelect: [
            ...new Set([...state.seniorsToSelect, ...seniorsFromThisHomeUnit]),
          ],
          focusedSeniors: state.focusedSeniors.filter(
            (senior) => !seniorsFromThisHomeUnitIds.includes(senior.id)
          ),
        };
      } else {
        return {
          ...state,
          homeUnitsSelected: [
            ...state.homeUnitsSelected,
            action.payload.homeUnit,
          ],
          seniorsToSelect: state.seniorsToSelect.filter(
            (senior) => !seniorsFromThisHomeUnitIds.includes(senior.id)
          ),
          focusedSeniors: [
            ...new Set([
              ...state.focusedSeniors,
              ...seniorsFromThisHomeUnit.filter(
                (senior) => !focusedSeniorsIds.includes(senior.id)
              ),
            ]),
          ],
        };
      }
    }
    case "SET_SENIOR": {
      const newFocusedSeniorsList = [
        ...state.focusedSeniors,
        action.payload.seniorSelected,
      ];
      return {
        ...state,
        seniorsToSelect: state.seniorsToSelect.filter(
          (senior) => senior.id !== action.payload.seniorSelected.id
        ),
        focusedSeniors: newFocusedSeniorsList,
        homeUnitsSelected: handleHomeUnit(
          state.homeUnitsSelected,
          action.payload.seniorSelected.homeUnitId,
          newFocusedSeniorsList,
          action.payload.seniors
        ),
      };
    }
    case "REMOVE_SENIOR": {
      const newFocusedSeniorsList = state.focusedSeniors.filter(
        (senior) => senior.id !== action.payload.seniorSelected.id
      );
      return {
        ...state,
        seniorsToSelect: [
          ...state.seniorsToSelect,
          action.payload.seniorSelected,
        ],
        focusedSeniors: newFocusedSeniorsList,
        homeUnitsSelected: handleHomeUnit(
          state.homeUnitsSelected,
          action.payload.seniorSelected.homeUnitId,
          newFocusedSeniorsList,
          action.payload.seniors
        ),
      };
    }
    default:
      return;
  }
};
